import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/reservation/bulk-update", payload);
  },
};
